// extracted by mini-css-extract-plugin
module.exports = {"newsletter":"V_dH"};